<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication" style="margin-top:3em;">Dedicated to the living and loving memory of</p>
<p class="ORIM-Dedication">Richard Ottens,</p>
<p class="ORIM-Dedication">Friend, educator, and gourmet extraordinaire. We miss you.</p>
<p class="ORIM-Dedication">“All things considered, we would rather be dining at The Arches … with you.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled21.vue?0053a108